import { render, staticRenderFns } from "./ReportWholesale.vue?vue&type=template&id=1a5219ca&scoped=true&"
import script from "./ReportWholesale.vue?vue&type=script&lang=js&"
export * from "./ReportWholesale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5219ca",
  null
  
)

export default component.exports